import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText.js';

gsap.registerPlugin(SplitText);

/**
 * ModelViewer component
 */
export default class HeroCore extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'HeroCore',
    refs: ['title', 'image', 'imageBis', 'surtitle', 'btns[]', 'background', 'badge[]'],
  };

  /**
   *
   */
  mounted() {
    const splitTitle = SplitText.create(this.$refs.title, { type: 'chars', mask: 'chars' });
    this.tl = gsap.timeline();
    this.tl.set(this.$refs.title, { autoAlpha: 1 });
    this.tl.set(this.$refs.surtitle, { autoAlpha: 1 });

    this.tl.set(this.$refs.image, { autoAlpha: 1 });
    this.tl.set(this.$refs.imageBis, { autoAlpha: 1 });

    this.tl.fromTo(
      this.$refs.surtitle,
      {
        yPercent: 150,
        scale: 0.5,
      },
      {
        yPercent: 0,
        scale: 1,
        duration: 0.8,
        ease: 'power4.out',
      },
    );

    this.tl.fromTo(
      splitTitle.chars,
      {
        xPercent: -140,
        skewX: -20,
      },
      {
        skewX: 0,
        xPercent: 0,
        stagger: 0.01,
        duration: 0.8,
        ease: 'power4.out',
      },
      '<=0.2',
    );

    this.tl.fromTo(
      [this.$refs.image, this.$refs.imageBis],
      {
        y: '140lvh',
      },
      {
        y: 0,
        stagger: 0.1,
        duration: 1.6,
        ease: 'expo.inOut',
        onComplete: () => {
          this.$refs.image.classList.add('floating-element');
          setTimeout(() => {
            this.$refs.imageBis.classList.add('floating-element');
          }, 1000);
        },
      },
      '<=-0.5',
    );

    this.tl.fromTo(
      this.$refs.btns,
      {
        y: -50,
        opacity: 0,
      },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        stagger: 0.4,
        ease: 'power4.out',
      },
    );

    this.tl.to(
      this.$refs.badge,
      {
        y: 0,
        opacity: 1,
        ease: 'power4.out',
        duration: 0.8,
      },
      '<=0.5',
    );

    gsap.to(this.$refs.background, {
      y: 300,
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
      },
    });

    gsap.to(this.$refs.image, {
      top: -120,
      scrollTrigger: {
        trigger: this.$el,
        start: '-40 top',
        end: 'center top',
        scrub: true,
      },
    });

    gsap.to(this.$refs.imageBis, {
      top: -100,
      scrollTrigger: {
        trigger: this.$el,
        start: '-40 0',
        end: 'center top',
        scrub: true,
      },
    });
  }
}
